<template>

    <div>
        <DeliveryAddressRedirect
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.RESTAURANT"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <RestaurantsTabLinks />
            </template>
        </DeliveryAddressRedirect>
    </div>

</template>

<script>
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import DeliveryAddressRedirect from '@/components/delivery/DeliveryAddressRedirect';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'RestaurantDeliveryAddressRedirect',

        components: {
            DeliveryAddressRedirect,
            RestaurantsTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/restaurants/${id}`)).data;
        },

        methods: {}
    }
</script>
